// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"6b4f5c8c","239":"61313610","453":"089e22ff","455":"bece6ec7","748":"5b22d663","977":"17801f1c"}[chunkId] + ".chunk.js";
};